import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"receipt-check, ticket"} maskId="square-filled-radius-0-stroke-1-IconReceiptCheck"><path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.0833L8.25 19.8167L12 21.8167L15.75 19.8167L20 22.0833V2H4ZM9 13H15V14H9V13ZM14.9571 7.30006L14.25 6.59295L11.1 9.74295L9.75 8.39295L9.04289 9.10005L11.1 11.1572L14.9571 7.30006Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconReceiptCheck;
